import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronDoubleLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0002 6.58594L4.58594 12.0002L10.0002 17.4144L11.4144 16.0002L7.41436 12.0002L11.4144 8.00015L10.0002 6.58594Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M17.0002 6.58594L11.5859 12.0002L17.0002 17.4144L18.4144 16.0002L14.4144 12.0002L18.4144 8.00015L17.0002 6.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDoubleLeft;
